<template>
  <div style="background-color: #fff;">
    <AchievementsHeader />
    <!-- <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjcg-kjcg.jpg" />
        </div>
      </a-carousel>
    </div> -->
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" :child="'achievements'" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            科技成果
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <div class="recruitmentSmallBox">
            <div class="recruitmentSmallInfo" v-for="(item, index) in dataSource" :key="index" @click="goDetail(item.id)">
              <div class="mask"></div>
              <div class="btn">
                <a-button style="background-color: #fc550b;color: #fff;">查看详情</a-button>
              </div>
              <div class="recruitmentBottomBox">
                <!-- <div class="recruitmentBottomTopBox">
                  <img :src="getImg(item.companyLogo)" alt="">
                </div> -->
                <div class="recruitmentBottomMiddleBox">{{ item.name }}<div class="recruitmentBottomRightBottom">
                  </div>
                </div>
                <div class="recruitmentBottomBottomBox">{{ item.achievementAbstract }}</div>
                <div class="recruitmentBottomBottomBottomBox">
                  <p>技术成熟度：
                    <dict-render :dict-obj="dictObjs['technical_maturity']" v-if="item.techMaturity"
                      :text="item.techMaturity"></dict-render>
                  </p>
                  <p>合作方式：
                    <dict-render :dict-obj="dictObjs['cooperation_methods']" v-if="item.cooperationWay"
                      :text="item.cooperationWay"></dict-render>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { getDistMixin, listMixin, dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import FilterInfo from '@/components/other/FilterInfo';
import { achievementFontInfo } from "@/api/achievementsService";
import { file_service } from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin, dictMixin],
  components: { AchievementsHeader, FilterInfo, DictRender, LayoutFooter },
  data() {
    return {
      dictNames: 'technical_maturity,cooperation_methods',
      title: '',
      queryParam: {},
      listUrl: achievementFontInfo.pageList,
      current: 1,
      pageSize: 10,
    }
  },
  mounted() {
    this.getDist('belong_techField')
    this.getDist('technical_maturity')
    this.getDist('result_type')
    this.title = this.$route.query.type
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['技术领域'] = this.technoSphereArr
      obj['search'] = 'technoSphere'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)


      let type = {}
      let type1 = {}
      let type2 = {}
      let type3 = {}
      type1['成熟度'] = this.techMaturityArr
      type['search'] = 'techMaturity'
      type2['arr'] = type1
      type3 = Object.assign(type, type2)
      list.push(type3)

      let arr = {}
      let arr1 = {}
      let arr2 = {}
      let arr3 = {}
      arr1['成果类型'] = this.achievementClassifyArr
      arr['search'] = 'achievementClassify'
      arr2['arr'] = arr1
      arr3 = Object.assign(arr, arr2)
      list.push(arr3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(id) {
      this.$router.push({
        path: '/achievements/components/recruitmentDetail',
        query: { type: '科技成果', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;
      min-height: 300px;

      .recruitmentSmallBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;

        .recruitmentSmallInfo {
          margin: 10px 0;
          width: 49%;
          border: 1px solid #dedede;
          cursor: pointer;
          position: relative;

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            background-color: #4c4c4c;
          }

          .btn {
            position: absolute;
            top: 40%;
            left: 40%;
            display: none;
          }

          .recruitmentBottomBox {
            overflow: hidden;
            padding: 10px 12px 0 12px;
            width: 100%;
            color: #333;
            font-size: 14px;
            // text-align: center;

            .recruitmentBottomTopBox {
              width: 44px;
              height: 44px;
              margin: 10px auto;
              border: 1px solid #dedede;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .recruitmentBottomMiddleBox {
              padding: 12px 0;
              font-size: 16px;
              font-weight: bold;
            }

            .recruitmentBottomBottomBox {
              color: #666;
              overflow: hidden;
              min-height: 42px;
              margin: 10px 0;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .recruitmentBottomBottomBottomBox {
              padding: 8px 0;
              color: #999;
            }
          }
        }

        .recruitmentSmallInfo:hover {
          border: none;
          -webkit-transition: all 0.3s ease 0s;
          transition: all 0.3s ease 0s;
          //border: 1px solid #ffffff;
          cursor: pointer;
          -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
          box-shadow: 0 5px 10px 1px #d2e6ff;

          .mask {
            display: block;
            opacity: 0.7;
          }

          .btn {
            display: block;
          }
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
